module.exports = __webpack_public_path__ + "img/Flag_of_Suriname.6905244b.svg";